import React, { useState } from "react"

import { LetsTalkProps } from "components/LetsTalk/types"
import * as styles from "./styles.module.scss"
import Dictionary from "../Dictionary"
import EmailDialog from "../EmailDialog"
import Footer from "../../Footer"
import Hero from "../Hero"
import LearnMore from "../LearnMore"
import LetsTalk from "../../LetsTalk"
import Section from "../Section"
import SummaryAccordion from "../SummaryAccordion"
import SummaryBar from "../SummaryBar"
import Videos, { VideosProps } from "../Videos"
import { FlowLearnMoreData, FlowQuestionId, FlowVocabularyData } from "types"

export interface EndProps {
  atEndScreen: boolean
  editHandler: (...args) => void
  finalOutcome: string
  outcomes: {
    options: object
    showSummary?: boolean
    lead: {
      askForEmail: boolean
      description: string
      title: string
    }
  }
  showContact?: boolean
  questions: object
  userAnswers: any
  vocabulary: FlowVocabularyData
  scheduleConversation: LetsTalkProps
  submitEmailCallback?: (...args) => void
  learnMoreData: FlowLearnMoreData
  videos: VideosProps
  currentQuestionId: FlowQuestionId
  editMode: boolean
}

const End: React.FC<EndProps> = ({
  atEndScreen,
  currentQuestionId,
  editHandler,
  finalOutcome,
  learnMoreData,
  outcomes,
  questions,
  scheduleConversation,
  showContact = true,
  submitEmailCallback,
  userAnswers,
  videos,
  vocabulary,
}) => {
  const [editMode, setEditMode] = useState(false)

  const toggleEdit = () => {
    setEditMode(!editMode)
  }

  return (
    <Section
      className={styles.end}
      flowKey={FlowQuestionId.End}
      currentId={currentQuestionId}
    >
      {outcomes.lead.askForEmail && !userAnswers.email && (
        <EmailDialog
          show={atEndScreen}
          onSubmit={submitEmailCallback}
          {...outcomes.lead}
        />
      )}
      <div className={styles.container}>
        <div className={styles.top}>
          {Object.keys(outcomes.options).map((id) => (
            <Hero
              outcome={finalOutcome}
              key={`end-hero-${id}`}
              id={id}
              {...outcomes.options[id]}
            />
          ))}
          {outcomes.showSummary && (
            <SummaryBar
              userAnswers={userAnswers}
              editToggleCallback={() => toggleEdit()}
            />
          )}
        </div>
        <div className={styles.bottom}>
          <div className={styles.bottomPadding}>
            {outcomes.showSummary && (
              <SummaryAccordion
                questionsData={questions}
                userAnswers={userAnswers}
                isOpen={editMode}
                editHandler={editHandler}
              />
            )}
            {videos && <Videos userAnswers={userAnswers} videos={videos} />}
            {learnMoreData && (
              <LearnMore
                learnMoreData={learnMoreData}
                userAnswers={userAnswers}
              />
            )}
            {vocabulary && (
              <Dictionary vocabulary={vocabulary} userAnswers={userAnswers} />
            )}
            {showContact && (
              <div data-qa="schedule-appointment">
                <LetsTalk {...scheduleConversation} />
              </div>
            )}
          </div>
          <Footer />
        </div>
      </div>
    </Section>
  )
}

export default End
